import type { TMessages } from '@/types/TMessages'

export const messages = {
  header: {
    title: 'Деньги для агробизнеса \n<Highlighted>без ежемесячных платежей</Highlighted>',
    button: 'Подать заявку',
    additionalButton: 'Получить консультацию',
    description: 'Получите деньги в течение 5 рабочих дней без лишних документов',
    details: {
      '1': { value: 'до 200 млн ₽', sign: 'размер кредита' },
      '2': { value: 'Без ежемесячных платежей', sign: 'Порядок погашения' },
      '3': { value: 'до 12 месяцев', sign: 'срок кредитования' },
    },
  },
  details: {
    list: {
      sum: {
        label: 'Сумма займа',
        value: 'до 200 млн руб',
      },
      repaymentProcedure: {
        label: 'Порядок погашения',
        value: 'без ежемесячных платежей',
      },
      loanTerm: {
        label: 'Срок кредитования',
        value: 'до 12 месяцев',
      },
      deadline: {
        label: 'Скорость выдачи займа',
        value: 'до 5 рабочих дней',
        subValue: 'полностью дистанционно',
        tooltip: 'С даты получения всей информации согласно <LinkToListOfDocuments>перечню</LinkToListOfDocuments>',
      },
    },
  },

  steps: {
    title: '<Highlighted>Этапы</Highlighted> получения денег',
    '1': {
      title: 'Консультация и предварительный расчет',
    },
    '2': {
      title: 'Предоставление документов / информации',
    },
    '3': {
      title: 'Согласование индивидуальных условий и подписание договора',
    },
    '4': {
      title: 'Получение денежных средств',
    },
    button: 'Подать заявку',
  },

  terms: {
    title: '<Highlighted>Условия</Highlighted> займа',
    items: {
      '1': {
        label: 'Сумма займа',
        value: 'от 300 тыс. руб до 200 млн руб.',
      },
      '2': {
        label: 'Срок займа',
        value: 'от 1 до 12 месяцев',
      },
      '3': {
        label: 'Регональное покрытие',
        value: 'ЮФО, ЦФО, ПФО, СЗФО, Ставропольский край',
      },
      '4': {
        label: 'Порядок погашения',
        value: 'без ежемесячных платежей, погашение основного долга и процентов в конце срока',
      },
      '5': {
        label: 'Досрочное погашение',
        value: 'досрочное погашение в любой момент до истечения срока договора без штрафов / пеней',
      },
      '6': {
        label: 'Обеспечение',
        value: 'залог прав собственности или залог прав долгосрочной аренды (от 20 лет) на земли с/х назначения',
      },
      '7': {
        label: 'Заимодавец',
        value:
          'Заём предоставляет ООО МКК «Поле Инвест», ИНН 9703172440, ОГРН 1247700112142, юридический адрес: 127006, г. Москва, вн. тер. г. муниципальный округ Тверской, ул. Краснопролетарская, д. 4, помещ. 2/1',
      },
    },
  },

  benefits: {
    title: '<Highlighted>Преимущества</Highlighted> продукта',
    items: {
      simpleProcedure: 'Простая процедура оформления и минимальный пакет документов',
      suitedFor: 'Подходит для рефинансирования кредитов или первоначального взноса по лизингу',
      earlyRepayment: 'Досрочное погашение без штрафов и пеней',
      replaymentAtEndOfTerm: 'Погашение займа одним платежом в конце срока, после продажи урожая',
      probabilityOfApproval: 'Вероятность одобрения фермерам до <AnnotationLink2>83%</AnnotationLink2> **',
      transferToAnyBank: 'Зачисление на счет в любом банке, без дополнительных услуг',
    },
  },

  aboutUs: {
    title: '<Highlighted>Отзывы</Highlighted> о нас',
    reviews: {
      1: {
        name: 'Павел Варламов',
        organization: 'ГКФХ Варламов П.Л.',
        quote: 'Мне одобрили заем «Поле Финанс» даже больший, чем мне был нужен. Условия – никаких ежемесячных платежей',
        description:
          'Я должен расплатиться в сентябре, после уборки, но вернуть уже не зерном, а деньгами. При этом в течение сезона я могу выбирать из оставшейся одобренной мне суммы средства в случае необходимости. Деньги на счет поступают в течение пары дней. Для агрария время — деньги, а собирать для банка огромный пакет документов, приезжать лично — это потеря времени, то есть «Поле Финанс» учитывает особенности сельхозбизнеса как в части подачи заявки, так и в части способов погашения',
        region: 'Волгоградская область',
        area: '2 500 Га',
      },
      2: {
        name: 'Александр Дьяконов',
        organization: 'ГКФХ Дьяконов А.Н.',
        quote:
          'Вариант погасить займ единовременно после уборки — оптимален. Не менее удобно и то, что я могу рассчитаться, реализовав сельхозпродукцию по хорошей цене там же, на Поле.РФ, через элеваторы, расположенные в Ростовской области. И деньги автоматически уйдут на закрытие займа',
        description:
          'Это чисто человеческий фактор: есть деньги в кармане, они быстро уходят. Другое дело, когда имеется некий доступный источник, куда можно обращаться по необходимости. Тогда средства расходуются более рационально, — рассуждает Дьяконов. — Мне одобрили сумму, большую, чем мне была нужна в тот момент, и я знаю, что в случае необходимости, мне есть на что рассчитывать. К примеру, сегодня из одобренной суммы мне понадобилось 100 тысяч рублей, мне их тут же перевели. Проценты начисляются только на фактически взятые средства. Если завтра мне понадобятся еще деньги, доступ к ним у меня есть. В текущих экономических условиях — это решение, которое реально помогает агробизнесу',
        region: 'Ростовская область',
        area: '600 Га',
      },
      3: {
        name: 'Анастасия Толманова',
        organization: 'АО «АГРОФИРМА СТАРОМАЙСКАЯ',
        quote:
          'Мы уже второй год работаем с Поле.РФ и всем довольны. Первый раз при оформлении авансирования были нюансы, но это связано больше с нашим Росреестром. В этом году все прошло прекрасно, брали средства дважды ',
        description:
          'Процедура была с минимумом документов, тем более сейчас у платформы есть свои оценки по арендным правам, что очень удобно. Не надо отдельно заказывать экспертизу оценки арендных прав, а это тоже лишние деньги, небольшие, но тем не менее. Нас это очень устраивает, потому что мы уже понимаем, кому продадим урожай, и цена хорошая. «Поле.РФ» совершенствуются в этом плане. Удовлетворены и сроками получения аванса: как мы планировали, так деньги и получили, в обещанный день, ничего не откладывалось. Эти деньги идут и на заработную плату нашим сотрудникам, это очень выгодно. Раньше нам приходилось брать кредиты, а процент там просто немыслимый был. У «Поле.РФ» тем удобно, что их базис поставки - элеватор, который у нас же здесь и находится. Мы продолжим сотрудничество, потому что именно для наших удаленных районов это очень удобный формат.\n\nВажно, что есть возможность всегда отсрочить платежи и прочее. Никаких штрафных санкций к нам не применяли, хотя мы первый год очень этого боялись. У нас были дожди, невовремя собрали урожай и не высушили. Но там все с пониманием относятся: «Не одни вы такие, бывает».',
        region: 'Ульяновская область',
        area: '3 989 Га',
      },
      4: {
        name: 'Сердюков Данил Александрович',
        organization: 'ГКФХ Сердюков Д.А.',
        quote:
          'Я взял авансирование под будущий урожай на платформе Поле.РФ. Все прошло отлично, мне помогал менеджер. Деньги пришли почти сразу, как собрали и отправили документы, примерно за 1,5-2 недели. ',
        description:
          'У нас хозяйство сейчас 1,8 тыс. гектаров, сеем в основном озимую пшеницу, яровой ячмень. Урожай неплохой планирую, по возможности буду увеличивать земельный банк и парк техники, поэтому возможно буду привлекать и субсидированные кредиты.',
        region: 'Волгоградская область',
        area: '1 800 Га',
      },
      5: {
        name: 'Феликс Гланц-Калустов',
        organization: 'Генеральный директор «ТД СТАФ»',
        description:
          'Мы уже несколько лет сотрудничаем с платформой Поле.РФ, было совершено множество сделок в разных регионах страны. Поле.РФ выступает не только своего рода маркетплейсом, но и гарантом качества и стабильности, а также дает возможность получить финансирование и топливо в рассрочку.',
        region: 'Волгоградская область',
      },
    },
  },

  discount: {
    title:
      'скидка <span class="h2 landingDiscountBanner__titleAccent">5%</span> на покупки на <a class="underline color_white link-no-hover" href="https://xn--e1alid.xn--p1ai/agricultural-products">поле.рф</a>',
    subtitle: 'При оформлении кредита получите скидку 5% на покупку сельхозтоваров на поле.рф',
    conditions: {
      item1: 'Оставьте заявку на кредит на поле.рф',
      item2: 'Оформите кредитный договор и получите персональный промокод на скидку 5% на товары на поле.рф *',
    },
    cite: 'В акции участвует ассортимент от: «СТК-АГРО», «Южный дом», «АгроВелес», «ОПТИМУМ», «КАШЕМИР КАПИТАЛ», «ИНОВАТОРС», «ТЕРМИНАЛ-ЛЫСЬВА», «АГРОДОМ-ЛИПЕЦК». Срок действия промокода – 6 месяцев. Все консультации по условиям акции осуществляет служба поддержки клиентов',
  },

  faq: {
    title: 'Часто задаваемые <Highlighted>вопросы</Highlighted>',
    questions: {
      requiredDocuments: {
        title: 'Какие документы необходимы для получения займа?',
        answer: `
            <p>Ознакомьтесь со списком необходимых документов:</p>
            <RequiredDocuments></RequiredDocuments>
        `,
      },
      useLoanInParts: {
        title: 'Можно ли использовать заем частями по мере необходимости?',
        answer:
          '<p>Да, деньги могут перечисляться частями в любом запрошенном заемщиком объеме, в любой рабочий день в течение всего срока действия договора займа.</p>',
      },
      earlyRepayment: {
        title: 'Возможно ли досрочное погашение займа?',
        answer:
          '<p>Да, досрочное погашение доступно в любое время без штрафных санкций. Мы пересчитаем сумму процентов к уплате исходя из фактического срока пользования полученными заемщиком деньгами.</p>',
      },
      collateralRequired: {
        title: 'Требуется ли залог для получения займа?',
        answer:
          '<p>Для получения займа требуется обеспечение в виде залога прав собственности или залога прав долгосрочной аренды на земли сельскохозяйственного назначения, находящиеся в обработке. Остаток срока аренды должен составлять не менее 10 лет для заемщиков из Краснодарского края, Республики Адыгея, Ставропольского края, Ростовской области, для заемщиков из других субъектов - не менее 20 лет.</p>',
      },
      landCollateral: {
        title: 'Для чего требуется обеспечение в виде залога земли, в чем его суть?',
        answer: `<p>На этапе запуска нашего собственного кредитного продукта обеспечение по займу в виде залога является обязательным при любой сумме кредита от 500 тыс до 200 млн руб, это объективно обосновано следующим:</p>
          <ul>
            <li>Обеспечить максимальный процент одобрения выдачи денег фермерам на поддержание и развитие бизнеса. Это делает кредитование доступнее для фермеров;</li>
            <li>Наличие залога создает дополнительную мотивацию для эффективного ведения хозяйства и своевременного погашения займа. Это свидетельствует о его желании развивать бизнес и вкладывать средства в его успешное будущее;</li>
            <li>Залог земли дает возможность отслеживать финансовое состояние бизнеса, урожайность и в случае возникновения критичных трудностей предотвратить неблагоприятные последствия для обеих сторон.</li>
          </ul>
          <Title>Важно подчеркнуть:</Title>
          <p>Мы как кредитная организация заинтересованы в успешном развитии земельных участков фермера и желаем предоставить необходимые средства для достижения этой цели. Залог служит гарантией возврата займа и создает условия для взаимовыгодного сотрудничества между нами и фермером, мы настроены на долголетнее партнерство.</p>
        `,
      },
      alreadyHaveLoan: {
        title: 'Можно ли получить заем если у меня уже есть другие займы / кредиты / лизинги?',
        answer:
          '<p>Да, вы можете получить займ, если у вас есть другие кредитные обязательства, однако это может повлиять на его максимальную сумму и обеспечение. Мы рекомендуем обсудить вашу ситуацию с нашим финансовым менеджером, мы найдем решение.</p>',
      },
      contacts: {
        title: 'Как я могу связаться с вашей организацией для получения консультации?',
        answer:
          '<p>Вы можете связаться с нами по телефону 8-800-707-03-85 или <OpenConsultingForm>подать заявку</OpenConsultingForm> на нашем сайте и финансовый менеджер сам свяжется с вами.</p>',
      },
      collateralValuationProcedure: {
        title: 'Как проходит процедура оценки залога?',
        answer:
          '<p>Оценка залога осуществляется нашими специалистами в полностью дистанционном формате. Мы используем комплексный подход, основанный на передовых геоинформационных системах и космических снимках с учетом как кадастровой, так и рыночной стоимости земли. Это обеспечивает максимальную прозрачность, объективность и скорость процесса оценки, что является преимуществом для всех участников сделки. Мы также можем привлечь независимых оценщиков, по желанию заемщика, что может увеличить максимально доступный лимит.</p>',
      },
    },
  },
  regionCoverage: {
    title: 'Карта регионального покрытия',
  },
  form: {
    title: 'Получите лучшее предложение по займу на любые бизнес-цели',
    description:
      'После отправки заявки в течение часа вам перезвонит финансовый менеджер <Highlighted>поле.рф</Highlighted> для уточнения запроса',
  },
  conditions: { title: 'Условия кредитования' },
  financingOffer: {
    hint: {
      forAgrariansOnly: 'Доступно только для аграриев',
    },
  },
  breadcrumbs: {
    currentPage: 'Деньги для агробизнеса',
  },
  request: {
    comment: {
      userClickedOnSubmitInPreApprovedPopup: 'предодобрение',
      fromProfileIndexPage: '',
      fromCalculator: 'Заявка из калькулятора займа лендинг МКК',
      fromRegionCoverageMap: 'Карта регионального покрытия',
    },
  },
} as const satisfies TMessages
